
import Vue from 'vue'

import {Component, Prop, Watch} from 'vue-property-decorator'
import {Action} from "vuex-class";
import {
  CREATE_NEW_REQUEST,
  FETCH_BOARDER_DATA,
} from "@/store/action-types";
import {NewRequestPayload} from "@/types/payload";
import SmartLink from "@/model/SmartLink";
import CustomerWithGroup from "@/model/CustomerWithGroup";
import {BoarderGroupsResponse, CustomerResponse} from "@/types/service-response";
import {TranslateResult} from "vue-i18n";
import i18n from "@/plugins/i18n";

function valueIsRequired(v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

function validateEmail(v: string): boolean | TranslateResult {
  if (v) {
    return /.+@.+\..+/.test(v) || i18n.t('validation.emailMustBeValid')
  }

  return true
}

@Component({

})export default class BoarderFoodOrderingRequest extends Vue {
  $refs!: {
    form: Vue & { validate(): boolean }
  }

  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: true}) readonly smartLink!: SmartLink

  @Action(CREATE_NEW_REQUEST) createNewRequest!: { (payload: NewRequestPayload): Promise<void> }
  @Action(FETCH_BOARDER_DATA) fetchData!: ({ (payload: string): Promise<CustomerWithGroup[]> })

  private isFormValid: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: TranslateResult = ''
  private isSaveInProgress: boolean = false
  private isLoading: boolean = false
  private currentFirstName: string = ''
  private currentFamilyName: string = ''
  private currentEmail: string = ''
  private currentPhoneNumber: string = ''
  private currentCustomer: any = null
  private currentBoarderGroup: any = null
  private boarderGroup: BoarderGroupsResponse[] = []
  private boarderData: any[] = []
  private isBoarderGroupSelectorDisabled: boolean = true
  private customer: any[] = []
  private checkBox: boolean = false


  private givenNameRules = [
    valueIsRequired
  ]

  private familyNameRules = [
    valueIsRequired
  ]

  private emailRules = [
    valueIsRequired,
    validateEmail
  ]

  private currentCustomerRules = [
    valueIsRequired
  ]

  private currentPhoneNumberRules = [
    valueIsRequired
  ]

  private currentBoarderGroupRules = [
    valueIsRequired
  ]

  @Watch('currentCustomer')
  watchCurrentCustomer (newVal: CustomerResponse): void {
    if(newVal) {
      this.currentCustomer = newVal
      this.currentBoarderGroup = null
    }
  }

  get getCustomerTitle (): string {
    if(this.smartLink.configuration[0].customers_label) {
      return this.smartLink.configuration[0].customers_label
    } else {
      return 'Zákazník'
    }

  }

  get getBoarderGroupTitle (): string {
    if(this.smartLink.configuration[0].boarder_group_label) {
    return this.smartLink.configuration[0].boarder_group_label
    } else {
      return 'Skupina'
    }
  }


  get filteredBoarderGroupList() {
    this.boarderGroup = []
    if(this.currentCustomer ) {
      if (this.smartLink.configuration[0].enabled_customers.length > 0) {
        this.isBoarderGroupSelectorDisabled = false
        const data: any | undefined = this.boarderData.find((item: CustomerWithGroup) => item.customer.id === this.currentCustomer.id)
        if (data) {
          let foundData: any | null = null
          this.smartLink.configuration.forEach((a: any) => {
            a.enabled_boarder_group.forEach((i: any) => {
              foundData = data.boarderGroups.find((b: BoarderGroupsResponse) => b.id.toString() === i.replace('/api/boarder-group/', ''))
              if (foundData) {
                this.boarderGroup.push(foundData)
              }
            })
          })
        }
      } else {
        this.isBoarderGroupSelectorDisabled = false
        const data: any | undefined = this.boarderData.find((item: CustomerWithGroup) => item.customer.id === this.currentCustomer.id)
        if (data) {
          let foundData: any | null = null
          this.boarderData.forEach((a: any) => {
            a.boarderGroups.forEach((i: any) => {
              foundData = data.boarderGroups.find((b: BoarderGroupsResponse) => b.id == i.id)
              if (foundData) {
                this.boarderGroup.push(foundData)
              }
            })
            })
      }
      }

    } else if(this.smartLink.configuration[0].enabled_customers.length == 1) {
      this.isBoarderGroupSelectorDisabled = false
      const id = this.smartLink.configuration[0].enabled_customers[0].replace('/api/customer/', '')
      const data: any | undefined = this.boarderData.find((item: CustomerWithGroup) => item.customer.id == id)
      if(data) {
        data.boarderGroups.forEach((i: BoarderGroupsResponse) => {
          this.boarderGroup.push(i)
        })
      }
    } else{
      this.isBoarderGroupSelectorDisabled = true
      this.boarderGroup = []
    }
    return this.boarderGroup
  }

  get filteredCustomerList(): any[] {
    let foundData: any[] = []
    let id: any | null = null
    if(this.smartLink.configuration[0].enabled_customers.length > 0) {
      this.smartLink.configuration[0].enabled_customers.forEach((item: any) => {
        id = item.replace('/api/customer/', '')
        foundData = this.boarderData.filter((g) => g.customer.id == id)
        foundData.forEach((a: any) => {
          this.customer.push(a.customer)
        })
      })
    } else {
      this.boarderData.forEach((a: any) => {
        this.customer.push(a.customer)
      })
    }

    return this.customer
  }

  get getCustomerName () {
      let test: any | null = null
      let id = this.smartLink.configuration[0].enabled_customers[0].replace('/api/customer/', '')
      const foundData = this.boarderData.filter((g) => g.customer.id == id)
      if(foundData ) {
        foundData.forEach((a: any) => {
          test = a.customer.name
        })

      }
      return test
  }

  onFormSubmit(): void {
    if((this.$refs.form.validate())) {
      this.onCreateNewRequest()
    }
  }

  async onCreateNewRequest(): Promise<void> {
    let customerId = this.smartLink.configuration[0].enabled_customers[0]
    let groupId = this.smartLink.configuration[0].enabled_boarder_group[0]
    let payload: NewRequestPayload = {
      tenant: this.smartLink.tenant,
      kind: `/api/request-kind/onboarding`,
      data: {
        firstName: this.currentFirstName,
        familyName: this.currentFamilyName,
        email: this.currentEmail,
        phoneNumber: this.currentPhoneNumber,
        customer: this.smartLink.configuration[0].enabled_customers.length == 1 ? customerId : `/api/customer/${this.currentCustomer.id}`,
        boarderGroup:this.smartLink.configuration[0].enabled_boarder_group.length == 1 ? groupId :`/api/boarder-group/${this.currentBoarderGroup.id}`,
        alreadyHaveAccount: this.checkBox
      }
    }
    try {
      this.isSaveInProgress = true
      await this.createNewRequest(payload)

    } catch (e) {
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('permalinkPage.createDataError')
      this.showSnackBar = true

    } finally {
      this.isSaveInProgress = false
      this.$emit('close')
    }
  }


  async fetchBoarderData():Promise<void> {
    const payload: string = this.smartLink.tenant

    try {
      this.isLoading = true
      const response = await this.fetchData(payload)
      this.boarderData = response
      this.isLoading = false
    } catch (e) {
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('orderPage.fetchDataError')
      this.showSnackBar = true
    }
  }

  mounted() {
    this.fetchBoarderData()
    this.isFormValid = false

  }

}
